import React, { useEffect, useState } from "react";
import { Grid } from "@material-ui/core";
import Controls from "../../../controls/Controls";
import { useForm, Form } from "../../../controls/useForm";
import { request } from "../../../../api/Service";
import { store } from "../../../../redux-store/store";

const initialFValues = {
  id: 0,
  name: "",
  address: "",
  cityId: "",
  stateId: "",
  countryId: "",
  zipcode: "",
  credit_customer: false,
  credit_amount: "",
  dateCreated: new Date(),
};

export default function AddLocationForm(props) {
  const { addCustomerInfo, recordForEdit, locationTypes } = props;
  const [states, setState] = useState([]);
  const validate = (fieldValues = values) => {
    let temp = { ...errors };

    if ("name" in fieldValues)
      temp.name = fieldValues.name ? "" : "This field is required.";
    if ("address" in fieldValues)
      temp.address = fieldValues.address ? "" : "This field is required.";
    if ("zipcode" in fieldValues)
      temp.zipcode = fieldValues.zipcode ? "" : "This field is required.";
    if ("cityId" in fieldValues)
      temp.cityId = fieldValues.cityId ? "" : "This field is required.";
    if ("countryId" in fieldValues)
      temp.countryId = fieldValues.countryId !== "" ? "" : "Select a Country";
    if ("stateId" in fieldValues)
      temp.stateId = fieldValues.stateId !== "" ? "" : "Select a State";

    // Only validate creditLimit if creditCustomer is true
    if ("credit_amount" in fieldValues) {
      temp.credit_amount =
        values.credit_customer && fieldValues.credit_amount === ""
          ? "Credit Limit is Required"
          : "";
    }

    setErrors({
      ...temp,
    });

    if (fieldValues === values)
      return Object.values(temp).every((x) => x === "");
  };

  const handleSelectChange = (e) => {
    const { name, value } = e.target;
    setValues({
      ...values,
      [name]: value,
    });

    validate({ [name]: value });
    request("get", {}, `api/Admin/get-states-dropdown/${value}`).then(
      (data) => {
        console.log(data);
        setState(data);
      }
    );
  };

  const { values, setValues, errors, setErrors, handleInputChange, resetForm } =
    useForm(initialFValues, true, validate);

  // const handleSubmit = (e) => {
  //   e.preventDefault();
  //   if (validate()) {
  //     var result = {
  //       ...values,
  //       companyId: store.getState().persistReducer.companyId,
  //     };
  //     addCustomerInfo(result, resetForm);
  //   }
  // };

  const handleSubmit = (e) => {
    e.preventDefault();

    // Set defaults if not already present in values
    if (values.credit_customer === undefined) {
      values.credit_customer = false;
    }
    if (values.credit_amount === "") {
      values.credit_amount = "0";
    }

    if (validate()) {
      const result = {
        ...values,
        companyId: store.getState().persistReducer.companyId,
      };
      addCustomerInfo(result, resetForm);
    }
  };

  useEffect(() => {
    if (recordForEdit !== null)
      setValues({
        ...recordForEdit,
      });
  }, [recordForEdit]);

  const [holdBtn, setHoldBtn] = useState(true);

  useEffect(() => {
    // Exclude `creditCustomer` and `creditLimit` from validation
    const filteredValues = Object.keys(values)
      .filter((key) => key !== "credit_customer" && key !== "credit_amount")
      .reduce((obj, key) => {
        obj[key] = values[key];
        return obj;
      }, {});

    // Check if all required fields (excluding `creditCustomer` and `creditLimit`) are filled
    const allValuesFilled = Object.values(filteredValues).every(
      (value) => value !== "" && value !== null && value !== undefined
    );

    // If creditCustomer is true, creditLimit must also be filled
    const creditCondition = values.credit_customer
      ? values.credit_amount !== "" &&
        values.credit_amount !== null &&
        values.credit_amount !== undefined
      : true;

    // Update button state based on conditions
    setHoldBtn(!(allValuesFilled && creditCondition));
  }, [values]);

  return (
    <Form onSubmit={handleSubmit}>
      <Grid container>
        <Grid item xs={6}>
          <Controls.Input
            label="Name*"
            name="name"
            value={values.name || ""}
            onChange={handleInputChange}
            error={errors.name}
          />
          <Controls.Select
            name="countryId"
            label="Countries"
            value={values.countryId || ""}
            onChange={handleSelectChange}
            options={props.countries}
            error={errors.countryId}
          />
          <Controls.Select
            name="stateId"
            label="State*"
            value={values.stateId || ""}
            onChange={handleInputChange}
            options={states}
            error={errors.stateId}
          />
        </Grid>
        <Grid item xs={6}>
          <Controls.Input
            label="Zip code*"
            name="zipcode"
            value={values.zipcode || ""}
            onChange={handleInputChange}
            error={errors.zipcode}
          />
          <Controls.Input
            label="City*"
            name="cityId"
            value={values.cityId || ""}
            onChange={handleInputChange}
            error={errors.cityId}
          />

          <Controls.Input
            label="Address*"
            name="address"
            value={values.address || ""}
            onChange={handleInputChange}
            error={errors.address}
          />

          <Controls.Checkbox
            label="Credit Customer*"
            name="credit_customer"
            value={values.credit_customer}
            onChange={handleInputChange}
            error={errors.credit_customer}
          />

          {values.credit_customer && (
            <Controls.Input
              label="Credit Limit*"
              name="credit_amount"
              value={values.credit_amount || ""}
              onChange={handleInputChange}
              error={errors.credit_amount}
            />
          )}

          <div>
            <Controls.Button disabled={holdBtn} type="submit" text="Submit" />
          </div>
        </Grid>
      </Grid>
    </Form>
  );
}
